import React, { useEffect } from 'react';
import useReveal from '../utils/useReveal';
import './Servicios.css';

const servicios = [
  {
    id: 'servicio-tecnico',
    numero: '01',
    titulo: 'Servicio Técnico',
    lead: 'Garantizamos el funcionamiento óptimo y confiable de sus equipos de pesaje, con soluciones técnicas integrales y un servicio excepcional en todo momento.',
    parrafo: 'Desde balanzas de precisión hasta sistemas de pesaje de alta capacidad, trabajamos en estrecha colaboración con cada cliente para comprender sus necesidades específicas y proporcionar soluciones personalizadas que maximicen la eficiencia y la precisión de sus procesos.',
    capacidades: [
      'Instalación y puesta en marcha',
      'Calibración con masas patrón',
      'Mantenimiento preventivo',
      'Mantenimiento correctivo'
    ],
    imagen: '/imagenes/calibracion-servicio-tecnico.webp',
    imagenAlt: 'Técnico calibrando báscula con masas patrón',
    badge: 'Atención en terreno'
  },
  {
    id: 'obras-civiles',
    numero: '02',
    titulo: 'Obras Civiles',
    lead: 'Planificamos, construimos y modificamos la infraestructura especializada que los sistemas de pesaje necesitan, en todo tipo de entornos industriales y comerciales.',
    parrafo: 'Nuestro equipo de ingeniería civil y construcción trabaja junto a los expertos en tecnología de pesaje en cada etapa del proyecto, desde el diseño inicial hasta la instalación final, con romanas diseñadas para soportar cargas pesadas y entregar mediciones confiables en entornos exigentes.',
    capacidades: [
      'Construcción de romanas de camiones',
      'Reparación y modificación',
      'Plataformas y estructuras de soporte',
      'Fundaciones y montaje en terreno'
    ],
    imagen: '/imagenes/obras-civiles-instalacion.webp',
    imagenAlt: 'Instalación y soldadura de plataforma de báscula de camiones',
    badge: 'Del diseño a la entrega'
  },
  {
    id: 'desarrollo',
    numero: '03',
    titulo: 'Desarrollo',
    lead: 'El núcleo de la innovación de Servibalanzas: ingeniería y software trabajando juntos para llevar la tecnología de pesaje más lejos.',
    parrafo: 'Desarrollamos software personalizado para aplicaciones de pesaje e integramos sensores, actuadores y sistemas de control automatizado, creando procesos que maximizan la productividad y minimizan el error humano en entornos industriales.',
    capacidades: [
      'Software de pesaje a medida',
      'Automatización de procesos',
      'Integración de sensores y control',
      'Investigación e innovación continua'
    ],
    imagen: '/imagenes/panel-control-automatizacion.webp',
    imagenAlt: 'Panel de control de proceso automatizado de pesaje',
    badge: 'Ingeniería + software'
  }
];

const scrollAServicio = (event, id) => {
  event.preventDefault();
  window.history.replaceState(null, '', `#${id}`);
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const Servicios = () => {
  useReveal();

  // Al entrar con #ancla (desde el menú del header o el footer), desplazar a la sección
  useEffect(() => {
    const { hash } = window.location;
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        const timer = setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 150);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  return (
    <div className="servicios">
      {/* Hero */}
      <section className="servicios-hero">
        <div className="container">
          <p className="eyebrow servicios-eyebrow" data-reveal>Qué hacemos</p>
          <h1 className="servicios-title" data-reveal style={{ '--reveal-delay': '0.1s' }}>
            Nuestros Servicios
          </h1>
          <p className="servicios-subtitle" data-reveal style={{ '--reveal-delay': '0.2s' }}>
            Una gama completa de servicios profesionales para cubrir todas las
            necesidades del pesaje industrial, de la fundación al software.
          </p>
          <nav className="servicios-nav" data-reveal style={{ '--reveal-delay': '0.3s' }}>
            {servicios.map((servicio) => (
              <a
                key={servicio.id}
                href={`#${servicio.id}`}
                className="servicios-nav-link"
                onClick={(event) => scrollAServicio(event, servicio.id)}
              >
                <span className="servicios-nav-num">{servicio.numero}</span>
                {servicio.titulo}
              </a>
            ))}
          </nav>
        </div>
      </section>

      {/* Fichas de servicio */}
      <section className="servicios-listado">
        <div className="container">
          {servicios.map((servicio, index) => (
            <article
              key={servicio.id}
              id={servicio.id}
              className={`servicio-ficha ${index % 2 === 1 ? 'reverse' : ''}`}
            >
              <div className="servicio-info">
                <span className="servicio-numero" data-reveal aria-hidden="true">{servicio.numero}</span>
                <h2 className="servicio-titulo" data-reveal style={{ '--reveal-delay': '0.05s' }}>
                  {servicio.titulo}
                </h2>
                <p className="servicio-lead" data-reveal style={{ '--reveal-delay': '0.1s' }}>
                  {servicio.lead}
                </p>
                <p className="servicio-parrafo" data-reveal style={{ '--reveal-delay': '0.15s' }}>
                  {servicio.parrafo}
                </p>
                <ul className="servicio-capacidades" data-reveal style={{ '--reveal-delay': '0.2s' }}>
                  {servicio.capacidades.map((capacidad) => (
                    <li key={capacidad}>{capacidad}</li>
                  ))}
                </ul>
              </div>
              <figure className="servicio-media" data-reveal style={{ '--reveal-delay': '0.15s' }}>
                <img src={servicio.imagen} alt={servicio.imagenAlt} loading="lazy" />
                <figcaption className="servicio-media-badge">{servicio.badge}</figcaption>
              </figure>
            </article>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-servicios">
        <div className="container">
          <div className="cta-servicios-content">
            <h2 data-reveal>¿Necesita un servicio específico?</h2>
            <p data-reveal style={{ '--reveal-delay': '0.1s' }}>
              Contáctenos para recibir una consulta personalizada y descubrir cómo
              podemos ayudarle a optimizar sus procesos de pesaje industrial.
            </p>
            <div className="cta-servicios-buttons" data-reveal style={{ '--reveal-delay': '0.2s' }}>
              <a
                href="https://wa.me/+56976234326?text=Hola,%20me%20interesa%20recibir%20una%20consulta%20personalizada%20sobre%20sus%20servicios%20de%20pesaje%20industrial"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cta-light"
              >
                Consulta por WhatsApp
              </a>
              <a href="tel:+56976234326" className="btn-cta-outline">
                Llamar ahora
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servicios;
